import { render, staticRenderFns } from "./AboutGallery.vue?vue&type=template&id=0b3ada5e&scoped=true&"
import script from "./AboutGallery.vue?vue&type=script&lang=js&"
export * from "./AboutGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3ada5e",
  null
  
)

export default component.exports